import hLeft from '../icon/assets/icons/h-left.svg';
import hRight from '../icon/assets/icons/h-right.svg';
import { html, nothing } from 'lit';
import componentStyles from './monogram-featured.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {classMap} from "lit-html/directives/class-map";
import {unsafeHTML} from "lit/directives/unsafe-html";

export default class MonogramFeatured extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * XS and LG images object.
       * @type {{src: string, altText: string}}
       */
      image: { type: Object },
      /**
       * Main content area text
       */
      bodyText: { type: String },
      /**
       * Image alignment
       */
      imageAlignment: { type: String },
      /**
       * Image Orientation
       */
      imageOrientation: { type: String },
      /**
       * Remove background icons if needed
       */
      noIcon: { type: Boolean },
      styleclass: { type: String },
      bottomOverflow: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.imageOrientation = 'landscape';
    this.noIcon = false;
    this.styleclass = '';
  }

  render() {
    return html`
      <div
        class="${classMap({
          'monogram-featured': true,
          'monogram-featured--no-bottom-margin': this.noIcon && this.bottomOverflow,
          [`monogram-featured--${this.styleclass}`]: !!this.styleclass,
        })}">
        <div class="monogram-featured__wrapper">
          <div
            class="${classMap({
              'monogram-featured__image-wrapper': true,
              'monogram-featured__image--no-icon': this.noIcon,
              [`monogram-featured__image--${this.imageAlignment}`]: true,
              [`monogram-featured__image--${this.imageOrientation}`]: true,
            })}"
          >
            ${this.noIcon ? nothing : html`
              <span class="monogram-featured__image--before">
              ${unsafeHTML(hLeft)}
            </span>`}

            <img
              class="${classMap({
                'monogram-featured__image': true,
                'monogram-featured__image--no-icon': this.noIcon,
              })}"
              src="${this.image.src}"
              alt=""
            />

            ${this.noIcon ? nothing : html`
              <span class="monogram-featured__image--after">
              ${unsafeHTML(hRight)}
            </span>`}
          </div>
          <div class="monogram-featured__content">
            <hf-wysiwyg markup="${this.bodyText}"></hf-wysiwyg>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-monogram-featured', MonogramFeatured);
